import React, { useState, useCallback, MouseEvent, memo } from 'react';
import { Drawer, Typography, Divider, List, ListItem, Button, Box } from '@material-ui/core';
import classNames from 'classnames';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { ModalConfirmacao } from '..';
import CropFreeIcon from '@material-ui/icons/CropFree';
import MenuIcon from '@material-ui/icons/Menu';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import { GetAuthLoginRedirect } from 'utils';
import { useStyles } from './cardapio-drawer-menu-styles';
import { useHistory, useParams } from 'react-router-dom';

export interface CardapioDrawerMenuProps {
  // wrapNavEdicao: () => void;
  setCarregando: (carregando: boolean) => any;
  onVisualizarClick: () => any;
  onEditarConfiguracoesClick: () => void;
  logout: () => any;
  buscarProds: () => any;
  capa?: string;
  adminLogado?: boolean;
  logoUrl?: string;
  mesaId?: string;
}

const CardapioDrawerMenu = ({
  // wrapNavEdicao,
  adminLogado,
  capa,
  logoUrl,
  mesaId,
  setCarregando,
  onVisualizarClick,
  onEditarConfiguracoesClick,
  logout,
  buscarProds,
}: CardapioDrawerMenuProps) => {
  const classes = useStyles({ capa });
  const [anchorMenu, setAnchorMenu] = useState<null | HTMLElement>(null);
  const [modal, setModal] = useState(false);

  const handleModal = useCallback(() => {
    setModal((prev) => !prev);
  }, []);

  const handleMenu = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      setAnchorMenu(event.currentTarget);
    },
    [setAnchorMenu],
  );
  const handleClose = useCallback(() => {
    setAnchorMenu(null);
  }, [setAnchorMenu]);

  const handleCloseWrapper = useCallback(
    (funcao, carregando?: boolean) => {
      handleClose();
      if (carregando) {
        setCarregando(carregando || false);
        carregando ? setTimeout(() => funcao(), 1) : funcao();
        window.location.assign(GetAuthLoginRedirect())
      }
      if (!carregando) {
        setCarregando(carregando || false);
        carregando ? setTimeout(() => funcao(), 1) : funcao();
      }
    },
    [handleClose, setCarregando],
  );

  const history = useHistory()
  const { empresaId } = useParams<{ empresaId: string }>()

  const navegarQrCode = useCallback(() => {
    history.push(`/${empresaId}/gerar-qrcode`);
  }, [empresaId, history]);


  return (
    <>
      <Box
        className={classNames(classes.menuDrawerIcon, classes.pointer)}
      >
        <Button
          aria-haspopup="true"
          onClick={handleMenu}
          color="primary"
          variant="contained"
        >
          <MenuIcon
            color="inherit"
            style={{ fontWeight: 'inherit', fontSize: '25' }}
          />
        </Button>
      </Box>
      <Drawer
        anchor="left"
        open={Boolean(anchorMenu)}
        onClose={handleClose}
        classes={{ paper: classes.drawer }}
      >
        <div className={classes.imagemCapa}>
          <img src={logoUrl} className={classes.logo} alt="Logo Empresa"></img>
        </div>
        <Divider />
        <List>
          {adminLogado ? (
            <>
              {/* Aqui ativa o modo deslogar */}
              <ListItem
                className={classes.listHover}
                onClick={() =>
                  handleCloseWrapper(onVisualizarClick, false)
                }
              >
                <>
                  <Typography
                    color="textPrimary"
                    className={classNames(classes.btnMenu, classes.pointer)}
                  >
                    <OpenInBrowserIcon color="inherit" style={{ marginRight: 10 }} />
                    Visualizar Catálogo
                  </Typography>
                </>
              </ListItem>
              <ListItem
                className={classes.listHover}
                onClick={() => handleCloseWrapper(navegarQrCode)}
              >
                <Typography
                  color="textPrimary"
                  className={classNames(classes.btnMenu, classes.pointer)}
                >
                  <CropFreeIcon color="inherit" style={{ marginRight: 10 }} />
                  Gerar Código QR
                </Typography>
              </ListItem>
              <ListItem
                className={classes.listHover}
                onClick={() => handleCloseWrapper(onEditarConfiguracoesClick)}
              >
                <Typography
                  color="textPrimary"
                  className={classNames(classes.btnMenu, classes.pointer)}
                >
                  <SettingsIcon color="inherit" style={{ marginRight: 10 }} />
                  Configurações
                </Typography>
              </ListItem>
            </>
          ) : (
            <>
              <ListItem
                className={classes.listHover}
                onClick={() => handleCloseWrapper(buscarProds)}
              >
                <Typography
                  color="textPrimary"
                  className={classNames(classes.btnMenu, classes.pointer)}
                >
                  <SearchRoundedIcon color="inherit" style={{ marginRight: 10 }} />
                  Buscar Produto
                </Typography>
              </ListItem>
            </>
          )}

          <Divider />
          {adminLogado ? (
            <ListItem
              className={classes.listHover}
              onClick={() => handleCloseWrapper(logout, false)}
            >
              <Typography
                color="textPrimary"
                className={classNames(classes.btnMenu, classes.pointer)}
              >
                <ExitToAppRoundedIcon color="inherit" style={{ marginRight: 10 }} />
                Deslogar
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              className={classes.listHover}
              onClick={() => handleCloseWrapper(logout, false)}
            >
              <Typography
                color="textPrimary"
                className={classNames(classes.btnMenu, classes.pointer)}
              >
                <AccountCircleRoundedIcon color="inherit" style={{ marginRight: 10 }} />
                Entrar
              </Typography>
            </ListItem>
          )}
        </List>
      </Drawer>

      <ModalConfirmacao
        aberto={modal}
        quandoLogar={logout}
        quandoCancelar={handleModal}
      />
    </>
  );
};

export const DrawerMenu = memo(CardapioDrawerMenu);
